import angular from 'angular';

(function () {
    'use strict';
    var core = angular.module('app.kissbuyer');

    core.constant(
        'KISS_BUYER',
        Object.freeze({
            buyer: {
                status: [
                    { value: 'CREATED', label: 'kiss_seller.status.created' },
                    { value: 'NOTIFIED', label: 'kiss_seller.status.notified' },
                    { value: 'ACTIVE', label: 'kiss_seller.status.active' },
                    { value: 'INACTIVE', label: 'kiss_seller.status.inactive' },
                    { value: 'DUPLICATE', label: 'kiss_seller.status.duplicate' },
                ],
                pagination: {
                    defaultPageSize: 20,
                    defaultSort: [
                        {
                            direction: 'ASC',
                            property: 'name',
                        },
                    ],
                    defaultPage: 0,
                },
                columnFieldMap: [
                    {
                        field: 'legalEntity.name',
                        property: 'name',
                    },
                    {
                        field: 'legalEntity.getIdentifiant()',
                        property: 'id',
                    },
                    {
                        field: 'getCountryLabel()',
                        property: 'country',
                    },
                    {
                        field: 'getLangLabel()',
                        property: 'lang',
                    },
                    {
                        field: 'invoiceSenderEmail',
                        property: 'senderemail',
                    },
                    {
                        field: 'getStatusLabel()',
                        property: 'status',
                    },
                    {
                        field: 'getLegalId()',
                        property: 'id',
                    },
                ],
            },
            // relation: {
            //     pagination: {
            //         defaultPageSize: 20,
            //         defaultSort: [
            //             {
            //                 direction: 'ASC',
            //                 property: 'principalName'
            //             }
            //         ],
            //         defaultPage: 0
            //     },
            //     columnFieldMap: [
            //         {
            //             field: 'principalName',
            //             property: 'principalName'
            //         },
            //         {
            //             field: 'buyer.getCountryLabel()',
            //             property: 'buyerCountry'
            //         },
            //         {
            //             field: 'buyer.getIdentifiant()',
            //             property: 'buyerIdent'
            //         },
            //         {
            //             field: 'buyer.name',
            //             property: 'buyerName'
            //         },
            //         {
            //             field: 'getLadType()',
            //             property: 'ladType'
            //         },
            //         {
            //             field: 'getDematMode()',
            //             property: 'dematMode'
            //         },
            //         {
            //             field: 'acceptation',
            //             property: 'ackDate'
            //         },
            //         {
            //             field: 'endOfValidity',
            //             property: 'eov'
            //         }
            //     ]
            // }
        })
    );
})();
